import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCatalogProductsIndex = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/productsindex" */
      '.'
    ),
);
